import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export const StyledButtonConfirm = withStyles({
  root: {
    fontFamily: 'MSBlack, Microsoft JhengHei, 微軟正黑體',
    borderRadius: '0px',
    width: '64px',
    background: '-webkit-linear-gradient(top, #f4ece1, #ddd1bb)',
    border: '1px solid #ddd1bb',
    padding: '0.4em 0.6em',
    minWidth: 'initail',
    '&:hover': {
      border: '1px solid #b52912',
      background: '#b52912',
      color: '#ddd1bb',
    },
  },
})(Button);

export const StyledButtonCancel = withStyles({
  root: {
    borderRadius: '0px',
    fontFamily: 'MSBlack, Microsoft JhengHei, 微軟正黑體',
    width: '64px',
    backgroundColor: '#fff',
    color: '#444',
    border: '1px solid transparent',
    borderColor: '#ccc',
    padding: '0.4em 0.6em',
    minWidth: 'initail',
    '&:hover': {
      border: '1px solid gray',
      background: 'white',
    },
  },
})(Button);

export const StyledIconButton = withStyles({
  root: {
    minWidth: 'initial',
    padding: '6px 8px',
    margin: '0 2px',
  },
  startIcon: {
    margin: 0,
  },
})(Button);
